import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from './supabase'

// Admin-controlled feature flags. Stored in admin_settings under key
// 'feature_flags' (public read). When a flag is false the surface is hidden
// (nav item gone, route redirects) so users never know it existed.
export const FLAG_DEFAULTS = {
  aisle: true,
  about: true,
  asoebi: true,
  todo: true,
  budget: true,
  become_vendor: false, // off for now
}

export const FLAG_LABELS = {
  aisle: 'Okoiya Aisle (vendor marketplace)',
  about: 'About page',
  asoebi: 'Aso Ebi',
  todo: 'Planning · To-Do tab',
  budget: 'Planning · Budget tab',
  become_vendor: 'Become a vendor (public application)',
}

let cache = null
let inflight = null

export function useFeatureFlags() {
  const [state, setState] = useState(cache ? { flags: cache, ready: true } : { flags: FLAG_DEFAULTS, ready: false })
  useEffect(() => {
    if (cache) { setState({ flags: cache, ready: true }); return }
    if (!inflight) {
      inflight = supabase.from('admin_settings').select('value').eq('key', 'feature_flags').maybeSingle()
        .then(({ data }) => { cache = { ...FLAG_DEFAULTS, ...(data?.value || {}) }; return cache },
              () => { cache = { ...FLAG_DEFAULTS }; return cache })
    }
    let live = true
    inflight.then(f => { if (live) setState({ flags: f, ready: true }) })
    return () => { live = false }
  }, [])
  return state
}

// Wrap a route's element. While flags load it shows nothing; once loaded, a
// disabled flag redirects away so the page is effectively invisible.
export function FlagGate({ flag, children, redirect = '/dashboard' }) {
  const { flags, ready } = useFeatureFlags()
  const navigate = useNavigate()
  const enabled = flags[flag] !== false
  useEffect(() => {
    if (ready && !enabled) navigate(redirect, { replace: true })
  }, [ready, enabled])
  if (!ready || !enabled) return null
  return children
}
